// Host-based routing: map the front-end host being served to its inbox API
// base URL. Mirrors admin's server/resolveApiPath.js, resolved on the client
// because the inbox is a static build with no per-request server.
//
// One deployment can serve multiple domains via API_PATH_MAPPING (JSON),
// keyed by "<host><router base>" because the version lives in the path, and
// valued by the inbox API base URL, e.g.:
//   REACT_APP_API_PATH_MAPPING={"inbox.cn.woztell.com/v1.0":"https://api.inbox.cn.woztell.com/v1.0","inbox.woztell.sanuker.com/v1.0":"https://api.inbox.woztell.sanuker.com/v1.0"}
//
// The router base comes from REACT_APP_ROUTER_BASE (the same value the app
// mounts yarr on), so one mapping can be shared across every version build. A
// host-only key is also honoured for deployments served from the root.
//
// The mapping is inlined at build time from process.env (CRA convention), so
// it must be passed as a build ARG like every other REACT_APP_* var. When it
// is unset or the current host is not mapped, every resolver falls back to its
// existing env var, so behavior is identical to the previous single-backend
// setup.

const API_PATH_MAPPING = process.env.REACT_APP_API_PATH_MAPPING
const ROUTER_BASE = process.env.REACT_APP_ROUTER_BASE || ""
const GRAPHQLAPI_PATH = process.env.REACT_APP_GRAPHQLAPI_PATH
const GRAPHQLAPI_SUBSCRIPTION_PATH = process.env.REACT_APP_GRAPHQLAPI_SUBSCRIPTION_PATH
const SERVER_API_PATH = process.env.REACT_APP_SERVER_API_PATH

let mapping = {}
try {
  mapping = API_PATH_MAPPING ? JSON.parse(API_PATH_MAPPING) : {}
} catch (error) {
  console.error("Invalid REACT_APP_API_PATH_MAPPING JSON, falling back to env paths", error)
  mapping = {}
}

// "/v1.0/" and "/" both normalise to a bare path so keys stay unambiguous
const normalizedBase = ROUTER_BASE.replace(/\/+$/, "")

// Every resolver must stay lazy: during the react-snap prerender pass
// window.location.host is the throwaway localhost server react-snap serves the
// build from, so any base resolved at module-evaluation time would be wrong.
// Callers therefore have to call these at request time, not hoist the result
// into a module-level const.
const mappedBase = () => {
  if (typeof window === "undefined") return undefined
  const { host } = window.location
  return mapping[`${host}${normalizedBase}`] || mapping[host]
}

// One line per distinct host, so a browser session shows the resolution once
// instead of on every GraphQL request.
// const loggedHosts = new Set()
// const debugResolution = (base) => {
//   if (typeof window === "undefined") return
//   const { host } = window.location
//   if (loggedHosts.has(host)) return
//   loggedHosts.add(host)
//   console.log("[resolveApiPath]", {
//     host,
//     routerBase: normalizedBase,
//     key: `${host}${normalizedBase}`,
//     mappedBase: base,
//     mappingKeys: Object.keys(mapping)
//   })
// }

export const resolveGraphqlApiPath = () => {
  const base = mappedBase()
  // debugResolution(base)
  return base ? `${base}/graphql` : GRAPHQLAPI_PATH
}

export const resolveGraphqlSubscriptionPath = () => {
  const base = mappedBase()
  return base ? `${base.replace(/^http/, "ws")}/graphql` : GRAPHQLAPI_SUBSCRIPTION_PATH
}

export const resolveServerApiPath = () => {
  const base = mappedBase()
  return base || SERVER_API_PATH
}
